"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "livraga": {
    "c6314ece": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "cantone": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "45af1977": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "ceregalla": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb288b7f": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "magnani": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30866ed4": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "nuova": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03fd1710": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "rampina": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35e9ff1a": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "ronchi": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "625933f7": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "skipSearch": false
    }],
    "vecchia": [{
      "hkey": "e664eeae",
      "slug": "livraga",
      "name": "Livraga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;